module.exports = __webpack_public_path__ + "static/21-are-smart-buildings-actually-that-intelligent-d4fe5aa9deede014b772819a9cd8f730.jpg";